import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { MapResponse } from '../helper/helper-api';

export const getActiveTenants = () => {
  return Jwt(AppSettings.REPORT_API_URL, false, {
    headers: [
      { key: 'access_token', value: localStorage.getItem('izendaToken') }
    ]
  })
    .get('/tenant/activeTenants')
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchDashboard = params => {
  const payload = {
    criterias: [
      {
        key: 'All'
      }
    ],
    isUncategorized: false,
    sortCriteria: {
      key: 'DashboardName',
      descending: false
    },
    tenantId: params.tenantId,
    includeGlobalCategory: true
  };

  return Jwt(AppSettings.REPORT_API_URL, false, {
    headers: [
      { key: 'access_token', value: localStorage.getItem('izendaToken') }
    ]
  })
    .post('/dashboard/search2', payload)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/izenda/api.js